module.exports = {
    apiUrl: 'https://api.nomadoffice.app',
    recaptchaSiteKey: '6Ldq3ywaAAAAAGh8qv8LEtKZSU_vDTh3sznDP54o',
    googleAnalyticsId: 'G-J7YVKCNC39',
};
